import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import NotificationService from "../services/NotificationService";

import {
  setNotifications,
  markAsRead,
  removeNotification,
} from "../store/slices/notification/notificationSlice";

import type {
  RootState,
  AppDispatch
} from "../store/store";

export const useNotification = () => {

  const dispatch: AppDispatch = useDispatch();

  const {
    notifications,
    unreadCount
  } = useSelector(

    (state: RootState) =>
      state.notifications
  );

  const [totalCount, setTotalCount] =
    useState<number>(0);

  // =========================================================
  // 🔁 REST API
  // =========================================================

  const refreshNotifications = async () => {

    try {

      const data =
        await NotificationService
          .fetchUserNotifications();

      dispatch(setNotifications(data));

    } catch (error) {

      console.error(
        "❌ Error sincronizando notificaciones:",
        error
      );
    }
  };

  const refreshTotalCount = async () => {

    try {

      const total =
        await NotificationService
          .fetchTotalCount();

      setTotalCount(total);

    } catch (error) {

      console.error(
        "❌ Error obteniendo total de notificaciones:",
        error
      );
    }
  };

  const refreshOnOpen = async () => {

    await Promise.all([

      refreshNotifications(),

      refreshTotalCount(),
    ]);
  };

  // =========================================================
  // 🚀 INITIAL LOAD
  // =========================================================

  useEffect(() => {

    refreshOnOpen();

  }, []);

  // =========================================================
  // ✅ MARK AS READ
  // =========================================================

  const handleMarkAsRead = async (
    id: string
  ) => {

    try {

      await NotificationService.markAsRead(id);

      dispatch(markAsRead(id));

      dispatch(removeNotification(id));

      setTotalCount((prev) =>
        prev > 0 ? prev - 1 : 0
      );

    } catch (error) {

      console.error(
        "❌ Error marcando como leída:",
        error
      );
    }
  };

  return {

    notifications,

    unreadCount,

    totalCount,

    refreshOnOpen,

    handleMarkAsRead,
  };
};